// assets
import TranslationOutlined from '@ant-design/icons/TranslationOutlined';
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import CommentOutlined from '@ant-design/icons/CommentOutlined';
import AuditOutlined from '@ant-design/icons/AuditOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import HistoryOutlined from '@ant-design/icons/HistoryOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';

// type
import { NavItemType } from '@/types/menu';

// icons
const icons = {
	TranslationOutlined,
	DatabaseOutlined,
	CommentOutlined,
	AuditOutlined,
	SafetyCertificateOutlined,
	HistoryOutlined,
	ToolOutlined,
	SettingOutlined
};

// ==============================|| MENU ITEMS - ADMINISTRARE ||============================== //

const administrare: NavItemType = {
	id: 'group-administrare',
	title: 'menu.administration',
	type: 'group',
	children: [
		{
			id: 'nomenclatoare',
			// Titlurile de meniu trec prin i18n (side-drawer și useNomenclatorTabs fac t(title))
			// — TOT meniul lateral stă în grupul `menu.*`, editabil din Gestionare texte.
			title: 'menu.nomenclatures',
			type: 'collapse',
			icon: icons.DatabaseOutlined,
			children: [
				{
					id: 'tipuri-proiecte', title: 'menu.projectTypes', type: 'item',
					url: '/common/types', requiredPermission: 'project_types:read'
				},
				{
					id: 'status-proiect', title: 'menu.projectStages', type: 'item',
					url: '/common/status-proiect', requiredPermission: 'project_stages:write'
				},
				{
					id: 'tipuri-anunt', title: 'menu.announcementTypes', type: 'item',
					url: '/common/tipuri-anunt', requiredPermission: 'announcement_types:write'
				},
				{
					id: 'stiluri-geometrie', title: 'menu.geometryStyles', type: 'item',
					url: '/common/stiluri-geometrie', requiredPermission: 'geometry_styles:read'
				},
				{
					id: 'tile-uri', title: 'menu.mapTiles', type: 'item',
					url: '/common/tile-uri', requiredPermission: 'map_tiles:write'
				},
				// Județe / UAT — nomenclatoare de referință read-only, gate-uite pe `:read`
				// (toate rolurile îl au implicit în seed; matricea RBAC permite revocarea).
				{
					id: 'judete', title: 'menu.counties', type: 'item',
					url: '/common/judete', requiredPermission: 'counties:read'
				},
				{
					id: 'uat', title: 'menu.uats', type: 'item',
					url: '/common/uat', requiredPermission: 'uats:read'
				}
			]
		},
		{
			// Mutat din grupul de acces în „Administrare" (redesign template), după Nomenclatoare.
			id: 'acces-roluri-permisiuni',
			title: 'menu.rolesPermissions',
			type: 'item',
			url: '/common/roles-permissions',
			icon: icons.SafetyCertificateOutlined,
			requiredPermission: ['roles:read', 'permissions:read'],
			requiredPermissionMode: 'all'
		},
		{
			id: 'gestionare-texte',
			title: 'menu.textSettings',
			type: 'collapse',
			icon: icons.TranslationOutlined,
			requiredPermission: 'translations:read',
			children: [
				{
					id: 'gestionare-texte-admin',
					title: 'menu.textSettingsAdmin',
					type: 'item',
					url: '/common/gestionare-texte/admin',
					requiredPermission: 'translations:read'
				},
				{
					id: 'gestionare-texte-mobile',
					title: 'menu.textSettingsMobile',
					type: 'item',
					url: '/common/gestionare-texte/mobile',
					requiredPermission: 'translations:read'
				}
			]
		},
		{
			id: 'feedback',
			title: 'menu.feedback',
			type: 'collapse',
			icon: icons.CommentOutlined,
			children: [
				{
					id: 'probleme-raportate',
					title: 'menu.feedbackBugs',
					type: 'item',
					url: '/common/feedback/bug',
					requiredPermission: 'feedbacks:read'
				},
				{
					id: 'complimente-primite',
					title: 'menu.feedbackCompliments',
					type: 'item',
					url: '/common/feedback/compliment',
					requiredPermission: 'feedbacks:read'
				},
				{
					id: 'sugestii-primite',
					title: 'menu.feedbackSuggestions',
					type: 'item',
					url: '/common/feedback/suggestion',
					requiredPermission: 'feedbacks:read'
				},
				{
					id: 'solicitari-suport',
					title: 'menu.feedbackSupport',
					type: 'item',
					url: '/common/feedback/support',
					requiredPermission: 'feedbacks:read'
				}
			]
		},
		{
			id: 'clauze',
			title: 'menu.clauses',
			type: 'collapse',
			icon: icons.AuditOutlined,
			children: [
				{
					id: 'termeni-conditii',
					title: 'menu.clausesTerms',
					type: 'item',
					url: '/common/clause/tc',
					requiredPermission: 'agreements:read'
				},
				{
					id: 'confidentialitate',
					title: 'menu.clausesPrivacy',
					type: 'item',
					url: '/common/clause/pp',
					requiredPermission: 'agreements:read'
				},
				{
					id: 'cookies',
					title: 'menu.clausesCookies',
					type: 'item',
					url: '/common/clause/gdpr',
					requiredPermission: 'agreements:read'
				}
			]
		},
		{
			id: 'versiuni',
			// Titlurile de meniu trec prin i18n (side-drawer face t(title)) — cheia e
			// editabilă din Gestionare texte.
			title: 'menu.versioning',
			type: 'item',
			url: '/common/version',
			icon: icons.HistoryOutlined,
			requiredPermission: 'mobile_releases:read'
		},
		{
			// Ultima în listă. Titlu text brut (t() acoperă și non-chei) — pagina e superadmin-only,
			// gate pe `settings:manage` (cheie sintetică; doar superadmin trece prin bypass-ul RBAC).
			id: 'setari',
			title: 'Setări',
			type: 'item',
			url: '/common/settings',
			icon: icons.SettingOutlined,
			requiredPermission: 'settings:manage'
		}
	]
};

export default administrare;
